export const normalizeStringToNFD = (text: string | number | boolean | null | undefined) => {
  if (text == null) return "";
  const str = String(text);
  const normalized = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return normalized.toLocaleLowerCase();
};
